"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.polyfillApp = exports.calculateDependencies = exports.polyfillApplication = exports.getDependents = exports.getDependencies = exports.declareDep = exports.whitelistDependencies = void 0;
// polyfill the unfinished support of apps logic
var uniq_1 = __importDefault(require("lodash/uniq"));
var semver_1 = __importDefault(require("semver"));
var cryptoassets_1 = require("@ledgerhq/cryptoassets");
var directDep = {};
var reverseDep = {};
// whitelist dependencies
exports.whitelistDependencies = [
    "Decred",
    "Decred Test",
    "Bitcoin",
    "Bitcoin Test",
    "Zcash",
    "Avalanche",
    "Avalanche Test",
];
function declareDep(name, dep) {
    if (exports.whitelistDependencies.includes(name)) {
        return;
    }
    directDep[name] = (directDep[name] || []).concat(dep);
    reverseDep[dep] = (reverseDep[dep] || []).concat(name);
}
exports.declareDep = declareDep;
// extra dependencies
[
    ["LBRY", "Bitcoin"],
    ["Ravencoin", "Bitcoin"],
    ["Resistance", "Bitcoin"],
    ["ZenCash", "Bitcoin"],
    ["[ L ] Market", "Ethereum"],
    ["1inch", "Ethereum"],
    ["Aave", "Ethereum"],
    ["Alkemi", "Ethereum"],
    ["Angle", "Ethereum"],
    ["APWine", "Ethereum"],
    ["ARTIS sigma1", "Ethereum"],
    ["cBridge", "Ethereum"],
    ["Cometh", "Ethereum"],
    ["Compound", "Ethereum"],
    ["DODO", "Ethereum"],
    ["EnergyWebChain", "Ethereum"],
    ["Euler", "Ethereum"],
    ["Kiln", "Ethereum"],
    ["kUSD", "Ethereum"],
    ["Lido", "Ethereum"],
    ["Morpho", "Ethereum"],
    ["Nested", "Ethereum"],
    ["OlympusDAO", "Ethereum"],
    ["Opensea", "Ethereum"],
    ["Paraswap", "Ethereum"],
    ["POAP", "Ethereum"],
    ["Rarible", "Ethereum"],
    ["Ricochet", "Ethereum"],
    ["RocketPool", "Ethereum"],
    ["RSK Test", "Ethereum"],
    ["RSK", "Ethereum"],
    ["Spool", "Ethereum"],
    ["Staderlabs", "Ethereum"],
    ["StakeDAO", "Ethereum"],
    ["ThunderCore", "Ethereum"],
    ["Volta", "Ethereum"],
    ["Yearn", "Ethereum"],
].forEach(function (_a) {
    var _b = __read(_a, 2), name = _b[0], dep = _b[1];
    return declareDep(name, dep);
});
// Nb Starting on version 2.1.0 Bitcoin family apps no longer depend on
// Bitcoin as a library. We will soon have the dependencies resolved from
// back-end but until then we need to manually remove them.
var versionBasedWhitelistDependencies = {
    Bitcoin: "2.1.0"
};
var getDependencies = function (appName, appVersion) {
    var maybeDirectDep = directDep[appName] || [];
    if (!appVersion || !maybeDirectDep.length) {
        return maybeDirectDep;
    }
    // If we don't have any direct dependencies, or the caller didn't
    // provide `appVersion` to compare against, we can skip the filter
    return maybeDirectDep.filter(function (dep) {
        var _a;
        var maybeDep = versionBasedWhitelistDependencies[dep];
        return !maybeDep || semver_1["default"].lt((_a = semver_1["default"].coerce(appVersion)) !== null && _a !== void 0 ? _a : "", maybeDep);
    });
};
exports.getDependencies = getDependencies;
var getDependents = function (appName) {
    return reverseDep[appName] || [];
};
exports.getDependents = getDependents;
var polyfillApplication = function (app) {
    var crypto = (0, cryptoassets_1.listCryptoCurrencies)(true, true).find(function (crypto) {
        return app.name.toLowerCase() === crypto.managerAppName.toLowerCase() &&
            (crypto.managerAppName !== "Ethereum" ||
                // if it's ethereum, we have a specific case that we must only allow the Ethereum app
                app.name === "Ethereum");
    });
    if (crypto && !app.currencyId) {
        return __assign(__assign({}, app), { currencyId: crypto.id });
    }
    return app;
};
exports.polyfillApplication = polyfillApplication;
var calculateDependencies = function () {
    (0, cryptoassets_1.listCryptoCurrencies)(true, true).forEach(function (currency) {
        if (!currency.managerAppName)
            return; // no app for this currency
        var family = (0, cryptoassets_1.findCryptoCurrencyById)(currency.family);
        if (!family || !family.managerAppName)
            return; // no dep
        if (family.managerAppName === currency.managerAppName)
            return; // same app
        declareDep(currency.managerAppName, family.managerAppName);
        if (!currency.isTestnetFor) {
            declareDep(currency.managerAppName + " Test", family.managerAppName);
        }
    });
};
exports.calculateDependencies = calculateDependencies;
var polyfillApp = function (app) {
    var dependencies = exports.whitelistDependencies.includes(app.name)
        ? []
        : app.dependencies;
    return __assign(__assign({}, app), { dependencies: (0, uniq_1["default"])(dependencies.concat((0, exports.getDependencies)(app.name, app.version))) });
};
exports.polyfillApp = polyfillApp;
//# sourceMappingURL=polyfill.js.map